import { CheckCircle2, Link2 } from 'lucide-react';

import { SoftCard } from '@/components/ui/soft-card';

import { HideButton } from './HideButton';
import { MarkAsDoneButton } from './MarkAsDoneButton';

/**
 * "Add a link to your Storefront on your socials" — the single biggest
 * self-attested win (storefrontLinkOnSocials). Controlled and server-persisted
 * via useLocalPotentialActions (NEA-5765); ported from the fresh-dashboard design.
 */
export function OwnChannelsBoost({ activated, uplift = 3, onToggle, hidden, onHide, onUnhide }) {
	return (
		<SoftCard className="relative overflow-hidden bg-white !p-5 md:!p-6">
			{activated ? <span className="absolute bottom-0 left-0 top-0 w-1 bg-success" aria-hidden /> : null}
			<div className="flex items-start gap-4">
				<div
					className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${activated ? 'bg-success text-white' : 'bg-success-soft text-success-soft-foreground'}`}
				>
					<Link2 className="h-5 w-5" />
				</div>
				<div className="min-w-0 flex-1">
					<div className="flex flex-wrap items-center gap-2">
						<h3 className="text-[15px] font-bold text-foreground md:text-base">
							{activated
								? 'Added Local Storefront link to social media bios'
								: 'Add a link to Local Storefront on your social media'}
						</h3>
						{activated ? (
							<span className="inline-flex items-center gap-1.5 rounded-full bg-success px-2.5 py-1 text-xs font-extrabold text-white">
								<CheckCircle2 className="h-3.5 w-3.5" /> Live · +{uplift}%
							</span>
						) : (
							<span className="inline-flex items-center gap-1 rounded-full border border-success/40 bg-white px-2.5 py-1 text-xs font-semibold text-success">
								<span aria-hidden className="h-2 w-2 rounded-full bg-success" /> +{uplift}%
							</span>
						)}
					</div>
					<p className="mt-1 text-sm text-muted-foreground">
						{activated
							? "Your customers now flow from your socials, email and website straight into your storefront's live local stock, and back."
							: 'Pointing your social media followers to your live local stock is the single biggest lever you control.'}
					</p>
				</div>
				{!activated && onHide ? hidden ? <HideButton onClick={onUnhide} mode="unhide" /> : <HideButton onClick={onHide} /> : null}
				<MarkAsDoneButton activated={activated} onToggle={onToggle} />
			</div>
		</SoftCard>
	);
}
